import { render } from "./AdminSpeakers.vue?vue&type=template&id=bde4ff22&scoped=true"
import script from "./AdminSpeakers.vue?vue&type=script&lang=js"
export * from "./AdminSpeakers.vue?vue&type=script&lang=js"

import "./AdminSpeakers.vue?vue&type=style&index=0&id=bde4ff22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde4ff22"]])

export default __exports__